// utils/handleRemoveFreelancer.js
export const handleRemoveFreelancers = ({
    previousSelectedFreelancers,
    currentSelectedFreelancers,
    watch,
    unregister,
    reset,
    setRemoveClickedDate,
    setDates,
    setSelectedTab,
    dates,
    vat,
    holidaySavings,
    selectedCustomer,
    setValue,
  }) => {
    let removedIndex = {};
    const invoiceHours = watch('invoiceHours');
    const currentCurrency = watch("currency");
  
    if (currentSelectedFreelancers) {
      setSelectedTab((prevState) => ({ ...prevState, index: 0 }));
  
      const currentItemsUserId = currentSelectedFreelancers?.map(item => item.userId);
  
      if (previousSelectedFreelancers !== undefined) {
        previousSelectedFreelancers?.forEach((item, index) => {
          if (!currentItemsUserId.includes(item.userId)) {
            removedIndex = { index, removedItem: true };
          }
        });
      }
  
      if (removedIndex?.removedItem && invoiceHours && invoiceHours[removedIndex?.index + 1] !== undefined) {
        Object.keys(invoiceHours[removedIndex.index + 1])?.forEach((date) => {
          unregister(`invoiceHours[${removedIndex.index + 1}]`);
          setRemoveClickedDate({
            dateStr: date,
            indexValue: removedIndex.index + 1,
          });
        });
  
        const allItems = [];
        let lastIndex;
        let NewDatesList = { ...dates };
        delete NewDatesList[removedIndex.index + 1];
        Object.keys(dates)?.forEach((items, index) => {
          lastIndex = index + 1;
          allItems.push(dates[items]);
        });
        allItems?.forEach((values, index) => {
          NewDatesList[index] = values;
        });
        NewDatesList[lastIndex] = [];
        setDates(NewDatesList);
  
        const freelancersCount = currentSelectedFreelancers.length;
        const array = [];
        const newArray = [];
        const removeItem = invoiceHours;
  
        Array.from({ length: freelancersCount + 2 }, () => []).forEach((_, index) => {
          if (removedIndex.index + 1 !== index) {
            array.push(removeItem[index] ? { ...removeItem[index] } : undefined);
          }
        });
  
        for (let i = 0; i <= array.length; i++) {
          if (array[i] !== undefined) {
            newArray[i] = array[i];
          }
        }
  
        reset({
          vat,
          invoiceHours: newArray,
          holidaySavings,
          selectedCustomer,
          freelancer: currentSelectedFreelancers,
          showDates: 'true',
        });
      } else {
        const freelancersCount = currentSelectedFreelancers.length;
  
        if (invoiceHours !== undefined && removedIndex.index !== undefined) {
          unregister(`invoiceHours[${removedIndex.index + 1}]`);
  
          const array = [];
          const newArray = [];
          const removeItem = invoiceHours;
  
          Array.from({ length: freelancersCount + 2 }, () => []).forEach((_, index) => {
            if (removedIndex.index + 1 !== index) {
              array.push(removeItem[index] ? { ...removeItem[index] } : undefined);
            }
          });
  
          for (let i = 0; i <= array.length; i++) {
            if (array[i] !== undefined) {
              newArray[i] = array[i];
            }
          }
  
          reset({
            vat,
            invoiceHours: newArray,
            holidaySavings,
            selectedCustomer,
            freelancer: currentSelectedFreelancers,
            showDates: 'true',
          });
        }
  
        const allItems = [];
        let lastIndex;
        let NewDatesList = { ...dates };
        delete NewDatesList[removedIndex.index + 1];
  
        Object.keys(dates)?.forEach((items, index) => {
          lastIndex = index + 1;
          allItems.push(dates[items]);
        });
  
        allItems?.forEach((values, index) => {
          NewDatesList[index] = values;
        });
        NewDatesList[lastIndex] = [];
        setDates(NewDatesList);
      }
    }
  
    setValue("currency", currentCurrency);
  };
  